export default __webpack_public_path__ + "static/media/John Light mode.f6b8d50a.svg";